import React from "react";
import { Route, Routes } from "react-router-dom";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login2 from "../auth/login/login-2";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";

const ALLRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Routes publiques */}
      <Route path="/" element={<Login2 />} />

      {/* Routes protégées */}
      <Route element={<Feature />}>
        {publicRoutes.map((route, idx) => (
          <Route path={route.path} element={<ProtectedRoute role={route.role} secure={true}>{route.element}</ProtectedRoute>} key={idx} />
        ))}
      </Route>

      <Route element={<AuthFeature />}>
        {authRoutes.map((route, idx) => (
          <Route path={route.path} element={<PublicRoute role={route.role} secure={false}>{route.element}</PublicRoute>} key={idx} />
        ))}
      </Route>

    </Routes>
  );
};

export default ALLRoutes;
